
















import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({
  name: 'rating-component',
})
export default class RatingComponent extends Vue {
  protected percent = 0;

  @Prop({
    type: Number,
    default: 100,
  })
  protected reviews: number | undefined;

  @Prop({
    type: Number,
    default: 100,
  })
  protected overallMark: number | undefined;

  private mounted() {
    if (this.overallMark) {
      const count1 = this.overallMark / 5;
      this.percent = count1 * 100;
    }
  }
}
